import api from '@/services/gateway/api';
import router from '@/vue-instance/router';
import store from '@/vue-instance/store';

const baseUrl = 'camp/mobile/tariffs';
const indexRoute = { name: 'camp.mobile-boosters-tariffs.index' };
const jsonConfig = {
  headers: {
    'Content-Type': 'application/json'
  }
};

function normalizeValidationErrors (error) {
  const status = error && error.response && error.response.status;
  if (status !== 422) {
    return;
  }
  const errors = error.response.data && error.response.data.errors;
  if (!errors) {
    return;
  }
  if (!Array.isArray(errors)) {
    return;
  }
  const normalized = {};
  errors.forEach((entry) => {
    if (entry && typeof entry === 'object') {
      Object.keys(entry).forEach((key) => {
        if (!normalized[key]) {
          normalized[key] = [];
        }
        normalized[key].push(String(entry[key]));
      });
    }
  });
  store.dispatch('validation/setErrors', normalized);
}

const state = {
  list: [],
  item: {}
};

const getters = {
  getList: (state) => state.list,
  getItem: (state) => state.item
};

const mutations = {
  setList (state, data) {
    state.list = data;
  },
  setItem (state, data) {
    state.item = data;
  },
  patchListItem (state, data) {
    state.list = state.list.map((item) => {
      if (item.id === data.id) {
        return { ...item, ...data };
      }
      return item;
    });
  }
};

const actions = {
  getList ({ commit }, payload) {
    const params = {};
    if (payload) {
      if (payload.operator) {
        params.operator = payload.operator;
      }
      if (payload.is_active !== undefined && payload.is_active !== null && payload.is_active !== '') {
        params.is_active = payload.is_active;
      }
    }
    return api.get(baseUrl, { params })
      .then((response) => {
        commit('setList', response.data.data);
      });
  },
  getItem ({ commit }, id) {
    return api.get(`${baseUrl}/${id}`)
      .then((response) => {
        commit('setItem', response.data);
      });
  },
  addItem (_, payload) {
    return api.post(baseUrl, payload, jsonConfig)
      .then(() => {
        router.push(indexRoute);
      })
      .catch((error) => {
        normalizeValidationErrors(error);
        throw error;
      });
  },
  editItem (_, payload) {
    return api.put(`${baseUrl}/${payload.id}`, {
      product_offer_id: payload.product_offer_id,
      name: payload.name,
      is_active: payload.is_active
    }, jsonConfig).then(() => {
      router.push(indexRoute);
    }).catch((error) => {
      normalizeValidationErrors(error);
      throw error;
    });
  },
  toggleVisibility ({ commit }, payload) {
    commit('patchListItem', { id: payload.id, is_active: payload.is_active });
    return api.patch(`${baseUrl}/${payload.id}/visibility`, {
      is_active: payload.is_active
    }, jsonConfig).then((response) => {
      commit('patchListItem', response.data);
      return response.data;
    }).catch((error) => {
      commit('patchListItem', { id: payload.id, is_active: !payload.is_active });
      throw error;
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
